import { render, staticRenderFns } from "./ruleList.vue?vue&type=template&id=90eb0bfa&scoped=true&"
import script from "./ruleList.vue?vue&type=script&lang=js&"
export * from "./ruleList.vue?vue&type=script&lang=js&"
import style0 from "./ruleList.vue?vue&type=style&index=0&id=90eb0bfa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90eb0bfa",
  null
  
)

export default component.exports